import React from "react";
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  IconButton, 
  Typography,
  Box,
  List,
  ListItem
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

const GlossaryDialog = ({ open, onClose, glossaryItems = [] }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        Glossary
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
          {glossaryItems.map((item, index) => (
            <ListItem 
              key={index}
              alignItems="flex-start" 
              sx={{ 
                flexDirection: 'column',
                py: 2,
                px: 0
              }}
            >
              <Typography 
                variant="body1" 
                sx={{ 
                  fontFamily: 'Lato',
                  fontWeight: 400,
                  fontSize: '14px',
                  lineHeight: '100%',
                  letterSpacing: '0%',
                  mb: 0.5
                }}
              >
                {item.title}
              </Typography>
              <Typography 
                variant="body2" 
                sx={{ 
                  fontFamily: 'Lato',
                  fontWeight: 400,
                  fontSize: '14px',
                  lineHeight: '100%',
                  letterSpacing: '0%',
                  color: '#767676',
                  pl: 0
                }}
              >
                {item.description}
              </Typography>
            </ListItem>
          ))}
        </List>
      </DialogContent>
    </Dialog>
  );
};

export default GlossaryDialog; 